import { render } from "./Inspector.vue?vue&type=template&id=638d759a"
import script from "./Inspector.vue?vue&type=script&lang=js"
export * from "./Inspector.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sjoshi6/git/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__